export const TITLE = 'Answer Points';
export const PLACEHOLDER = '1';
export const MESSAGE = 'The point rewarded to the student if this is their answer.';
